import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { connect } from 'react-redux';

import { postOrder } from '../../../modules/actions/account/orders';
import Button from '../form-elements/Button';
import Modal from '../Modal/Modal';

function RetoureForm({ orderId, productId, action, postOrder }) {
    const [isOpen, setIsOpen] = useState(false);

    const initialValues = Object.fromEntries(action.modalFields.map(field => [field.placeholderRef, '']));

    const closeModal = () => {
        const el = document.getElementById(`refund-${action._id}`);
        window.UIkit.modal(el).hide();
    };

    const handleRetoureSubmit = async (values, actions) => {
        action.userInputs = values;
        await postOrder({ orderId, productId, action });
        closeModal();
        actions.setSubmitting(false);
    };

    return (
        <div style={{ display: 'initial' }}>
            <Button onClick={() => setIsOpen(true)}>{action.actionLabel}</Button>
            <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} contentLabel="Widerruf Modal">
                <Formik
                    initialValues={initialValues}
                    onReset={closeModal}
                    onSubmit={handleRetoureSubmit}
                    render={() => {
                        return (
                            <Form className="uk-form uk-margin-auto-vertical">
                                <div className="uk-modal-body">
                                    <h2 className="uk-modal-title">{action.actionLabel}</h2>
                                    <p>{action.modalText}</p>
                                    {action.modalFields.map(({ type, placeholderRef, required }, index) => {
                                        return (
                                            <div key={index} className="uk-margin">
                                                <Field
                                                    component="textarea"
                                                    className="uk-textarea"
                                                    name={placeholderRef}
                                                    type={type}
                                                    required={required}
                                                />
                                                <ErrorMessage component="div" className="uk-text-danger" name={placeholderRef} />
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="uk-modal-footer uk-text-right">
                                    <Button type="submit">{action.actionLabel}</Button>{' '}
                                    <Button onClick={() => setIsOpen(false)}>Vorgang abbrechen</Button>
                                </div>
                            </Form>
                        );
                    }}
                />
            </Modal>
        </div>
    );
}

const mapDispatchToProps = {
    postOrder,
};

export default connect(null, mapDispatchToProps)(RetoureForm);
